import { ApiResponseWithData, EventPurchaseLimits } from "./models";
import { getJson } from "../../../../utils";
import { constants } from "../../common";
import { createReadthroughCache } from "./apiCache";

const apiCall = () => getJson<ApiResponseWithData<EventPurchaseLimits[]>>(constants.urls.basketV2.limits);
const fetchBasketLimits = createReadthroughCache("basket/limits", 60_000, apiCall);

export default fetchBasketLimits;
